import app from '@core/configApp.ts'
import Aura from '@primevue/themes/aura'
import primeNl from 'primelocale/nl.json'
import BadgeDirective from 'primevue/badgedirective'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmPopup from 'primevue/confirmpopup'
import Ripple from 'primevue/ripple'
import StyleClass from 'primevue/styleclass'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'

import Tooltip from 'primevue/tooltip'

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.app-dark',
    },
  },
  locale: primeNl.nl,
})
app.directive('styleclass', StyleClass)
app.directive('tooltip', Tooltip)
app.directive('ripple', Ripple)
app.use(ToastService)
app.component('Toast', Toast)
app.component('ConfirmDialog', ConfirmDialog)
app.component('ConfirmPopup', ConfirmPopup)
app.use(ConfirmationService)
app.directive('badge', BadgeDirective)
